import Vue from 'vue';
import Vuex from 'vuex';
import fastQuoteModule from './modules/fastquote';
import toastr from './modules/toastr';
import quoteModule from './modules/quote';
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBeV8qzj-t-i74qWimWRd4tCI3fktXzQvI",
  authDomain: "dash-move.firebaseapp.com",
  projectId: "dash-move",
  storageBucket: "dash-move.firebasestorage.app",
  messagingSenderId: "454194456705",
  appId: "1:454194456705:web:00104d38306a635fd98580",
  measurementId: "G-3YJNWGJP2F"
};

initializeApp(firebaseConfig);

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    fastQuote: fastQuoteModule,
    quote: quoteModule,
    toastr
  }
});
export default store;
